import { render, staticRenderFns } from "./LimitedFeaturePill.vue?vue&type=template&id=2358ff13&scoped=true"
import script from "./LimitedFeaturePill.vue?vue&type=script&lang=js"
export * from "./LimitedFeaturePill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358ff13",
  null
  
)

export default component.exports